import DropdownProjectsArea from 'components/cards/token-card/dropdown-projects-area/dropdown-projects-area';

import { SelectMoneyWrapper } from './occ-card.style';
import { useAppSelector } from 'redux/use-hooks';
import { selectOneTokenProjects } from 'redux/slices/tokens';

const OCCCard = () => {
  const projects = useAppSelector(selectOneTokenProjects);

  if (projects.length === 0) return null;

  return (
    <SelectMoneyWrapper>
      <DropdownProjectsArea options={projects} />
    </SelectMoneyWrapper>
  );
};

export default OCCCard;
